import _ from 'lodash'
import getTout from './supportedTouts'

export default function parseTouts(lobbyGameTouts) {
  let touts = []
  if (lobbyGameTouts) {
    touts = _.map(lobbyGameTouts, tout => {
      const toutObject = getTout(tout.gameTemplate)
      toutObject.asset = null
      if (tout.game[0]) {
        toutObject[0].asset = _.omit(tout.game[0], ['__typename', 'gameId'])
        toutObject[0].asset.id = tout.game[0].gameId
      } else {
        return null
      }
      return toutObject
    }).filter(t => !!t)
  }
  return touts
}
